// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSessionRefreshBody = {
  refreshToken: string;
};

export type typeSessionRefreshOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    accessToken: string;
    refreshToken: string;
    expiresInSeconds: number;
  };
};

export type typeSessionRefreshOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSessionRefreshOutput403 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSessionRefreshOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSessionRefreshBody = {
  type: "object",
  properties: {
    refreshToken: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["refreshToken"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSessionRefresh(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSessionRefreshBody);
  }

  return async function postSessionRefresh(
    payload: typeSessionRefreshBody,
  ): Promise<typeSessionRefreshOutput200 | typeSessionRefreshOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSessionRefresh" failed before calling the network. #b606ca918c1e`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#b606ca918c1e" },
        },
        data: null,
      } as typeSessionRefreshOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/session/refresh`,
      httpMethod: "POST",
      options,
    })) as typeSessionRefreshOutput200 | typeSessionRefreshOutput400;
  };
}
